const Screen = ({ children, className }) => <div className={'w-screen h-full min-h-screen bg-purple flex items-center justify-center overflow-hidden' + (className || '')}>
  <div className='flex flex-col w-auto'>
    {children}
  </div>
</div>;

export default Screen;